/**
 * プロジェクト名など共通クラスから利用する変数を保持
 */
export var ServiceConfig;
(function (ServiceConfig) {
    ServiceConfig.ServiceName = 'Ready';
})(ServiceConfig || (ServiceConfig = {}));
